import { Card, CardContent, Stack, Typography } from '@mui/material';

// import { ReactComponent as AuditReady } from 'assets/images/ic_audit_readiness.svg';

import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';

const NoMCPGuard = (): React.ReactElement => (
  <Card variant="outlined">
    <CardContent>
      {/* <SvgIcon
        component={ShieldOutlinedIcon}
        inheritViewBox
        className="view-icon"
        fontSize="inherit"
        htmlColor="#3D3C42"
      /> */}
      <ShieldOutlinedIcon className="view-icon" sx={{ fill: '#3D3C42' }} />
      <Stack
        direction="column"
        spacing={4}
        justifyContent="center"
        alignItems="center"
      >
        <Typography variant="h6">No proxy traffic yet</Typography>
        <Typography component="span">
          Register an upstream MCP server, create an API key, and start routing
          MCP traffic through the proxy to see enforcement data here.
        </Typography>
      </Stack>
    </CardContent>
  </Card>
);

export default NoMCPGuard;
